import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import Tags from '@base/Tags/Tags';
import P2 from '@base/P2/P2';
import H6 from '@base/H6/H6';
import Link from '@base/Link/Link';
import TestThumbnail from '@base/TestThumbnail/TestThumbnail';
import { dateWithTime } from '@utils/dates';
import Item, { getQuizInfoString } from '@models/Item';
import AuthorHeader from './AuthorHeader';
import MessageDivider from './MessageDivider';
import { Spacings } from '../../../styleConstants';
import Card from './Card';

const Flex = styled.div`
  display: flex;
`;

const StyledCard = styled(Card)`
  margin-top: 16px;
  display: flex;
  flex-direction: column;
`;

const TimeTag = styled(Tags)`
  color: var(--color-text-secondary);
  margin-bottom: ${Spacings.SPACING_2};
`;

const Content = styled.div`
  margin-left: ${Spacings.SPACING_4B};
  display: flex;
  flex-direction: column;
`;

const LessonInfo = styled(P2)`
  margin-top: ${Spacings.SPACING_2B};
`;

const EmbeddedQuizCard = ({ story, batch }) => {
  const { message, created_at, author, object } = story;
  const classData = Item.getEntityData(object);
  const { liveAtString, name, specialInfoString, relativeLink } = classData;
  return (
    <>
      <AuthorHeader
        subtitle={batch && object.collection_name}
        author={author}
        created_at={created_at}
      />
      <StyledCard>
        <MessageDivider message={message} />
        <Link as={relativeLink} href="/quiz/[quizSlug]/[quizUID]">
          <Flex>
            <TestThumbnail color={object?.collection?.programme?.goal?.color} />
            <Content>
              <TimeTag type="transparent">{dateWithTime(liveAtString)}</TimeTag>
              <H6 color="var(--color-text-primary)">{name}</H6>
              <LessonInfo color="var(--color-text-secondary)">
                {specialInfoString || getQuizInfoString(classData, true)}
              </LessonInfo>
            </Content>
          </Flex>
        </Link>
      </StyledCard>
    </>
  );
};

export default EmbeddedQuizCard;

EmbeddedQuizCard.propTypes = {
  story: PropTypes.objectOf(PropTypes.any).isRequired,
  batch: PropTypes.bool
};

EmbeddedQuizCard.defaultProps = {
  batch: false
};
